export default __webpack_public_path__ + "static/media/Ballroll_00327.66bcae9b.png";